import React from 'react'

const WalletIcon = ({ fill = 'currentColor', width = 24, height = 24, ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M24.0066 9.33309H28.0066C28.743 9.33309 29.3399 9.93004 29.3399 10.6664V26.6664C29.3399 27.4028 28.743 27.9998 28.0066 27.9998H4.00655C3.27018 27.9998 2.67322 27.4028 2.67322 26.6664V5.33309C2.67322 4.5967 3.27018 3.99976 4.00655 3.99976H24.0066V9.33309ZM5.33988 11.9998V25.3331H26.6732V11.9998H5.33988ZM5.33988 6.66642V9.33309H21.3399V6.66642H5.33988ZM20.0066 17.3331H24.0066V19.9998H20.0066V17.3331Z" fill={fill} />
    </svg>

  )
}

export default WalletIcon
